import React, { useEffect, useState } from 'react';
import MainBody from './body';
import { Link, useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import useSWR from 'swr';
import { IoIosArrowBack } from "react-icons/io";
import { PiDotsThreeLight } from "react-icons/pi";
import { URLS } from '../../../Services/Urls';
import {API} from '../../../Services/axios'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setProjectData } from '../../../Redux/Store/Slices/projectReducer';
import { toast } from 'react-toastify';


//const fetcher = url => API.get(url).then(res => res.data)



const StructureContent = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [isSaving, setIsSaving] = useState(false);
  let { projetId } = useParams();
  const project = useSelector((state) => state.project);
  const navigate = useNavigate();

  const dispatch = useDispatch();

  // const { data: proj, error, isValidating } = useSWR(URLS.PROJECT.details(projetId));

  // Define steps and sections based on project data
  const steps = project?.steps || [];

  // Handle click on sidebar links
  const handleStepClick = (index) => {
    setActiveStep(index);
  };

  const formatProjectType = (type) => {
    return type.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
  };

  const handleSave = async () => {
    try {
      setIsSaving(true);
      
      // Verify that choices have product_ref or linked_product BEFORE saving
      let hasProductRefs = false;
      const choiceWithProductRef = { stepIdx: null, sectionIdx: null, choiceIdx: null, choiceId: null, productRef: null, linkedProduct: null };
      
      project.steps?.forEach((step, stepIdx) => {
        step.sections?.forEach((section, sectionIdx) => {
          const choices = section.choice_items || section.choices || [];
          choices.forEach((choice, choiceIdx) => {
            const productId = choice.product_ref || choice.linked_product;
            if (productId) {
              console.log(`✓ AVANT sauvegarde - Step ${stepIdx}, Section ${sectionIdx}, Choice ${choiceIdx} (${choice.id}): product_ref = ${choice.product_ref}, linked_product = ${choice.linked_product}`);
              hasProductRefs = true;
              if (choice.id === '297a268b-bad7-4e74-9f33-945e63778ee4') {
                choiceWithProductRef.stepIdx = stepIdx;
                choiceWithProductRef.sectionIdx = sectionIdx;
                choiceWithProductRef.choiceIdx = choiceIdx;
                choiceWithProductRef.choiceId = choice.id;
                choiceWithProductRef.productRef = choice.product_ref;
                choiceWithProductRef.linkedProduct = choice.linked_product;
              }
            }
          });
        });
      });
      
      if (hasProductRefs) {
        console.log('✅ Des product_ref ou linked_product sont présents AVANT la sauvegarde');
        if (choiceWithProductRef.choiceId) {
          console.log('Choix avec produit trouvé:', choiceWithProductRef);
          // Log the exact structure of this choice in the project
          const step = project.steps[choiceWithProductRef.stepIdx];
          const section = step?.sections[choiceWithProductRef.sectionIdx];
          const choice = (section?.choice_items || section?.choices || [])[choiceWithProductRef.choiceIdx];
          console.log('Structure complète du choix dans le projet:', JSON.stringify(choice, null, 2));
        }
      } else {
        console.warn('⚠️ ATTENTION: Aucun product_ref ou linked_product trouvé dans les choix avant la sauvegarde !');
        console.warn('Le projet dans Redux ne contient pas les produits mis à jour.');
      }
      
      // Log a sample of the project structure to see if product_ref or linked_product is included
      console.log('Échantillon du projet à sauvegarder (Step 1, Section 14):', 
        JSON.stringify(project.steps?.[1]?.sections?.[14], null, 2));
      
      // Log the exact payload being sent to the backend
      const payloadToSend = {
        ...project,
        // Ensure we're sending the minimal required fields
        id: project.id,
        project_type: project.project_type,
        name: project.name,
        steps: project.steps,
      };
      
      console.log('Payload complet envoyé au backend:', JSON.stringify(payloadToSend, null, 2));
      console.log('Taille du payload:', JSON.stringify(payloadToSend).length, 'caractères');
      
      // Check if the choice with product_ref or linked_product is in the payload
      const choiceInPayload = payloadToSend.steps
        ?.flatMap(step => step.sections || [])
        .flatMap(section => section.choice_items || section.choices || [])
        .find(c => c.id === '297a268b-bad7-4e74-9f33-945e63778ee4');
      
      if (choiceInPayload) {
        console.log('Choix trouvé dans le payload:', choiceInPayload);
        console.log('product_ref dans le payload:', choiceInPayload.product_ref);
        console.log('linked_product dans le payload:', choiceInPayload.linked_product);
      } else {
        console.warn('⚠️ Le choix n\'a pas été trouvé dans le payload !');
      }
      
      // Try to update choices individually using the BE admin endpoint
      // First, collect all choices that need to be updated
      const choicesToUpdate = [];
      project.steps?.forEach((step) => {
        step.sections?.forEach((section) => {
          const choices = section.choice_items || section.choices || [];
          choices.forEach((choice) => {
            if (choice.product_ref || choice.linked_product) {
              choicesToUpdate.push({
                choiceId: choice.id,
                product_ref: choice.product_ref,
                linked_product: choice.linked_product,
              });
            }
          });
        });
      });
      
      // Update each choice individually if the endpoint exists
      if (choicesToUpdate.length > 0) {
        console.log(`${choicesToUpdate.length} choix à mettre à jour individuellement`);
        for (const { choiceId, product_ref, linked_product } of choicesToUpdate) {
          try {
            console.log(`Tentative de mise à jour du choix ${choiceId} avec product_ref=${product_ref}, linked_product=${linked_product}`);
            await API.patch(URLS.BE.CHOICES.update(choiceId), {
              product_ref: product_ref,
              linked_product: linked_product,
            });
            console.log(`✅ Choix ${choiceId} mis à jour avec succès`);
          } catch (error) {
            console.warn(`⚠️ Impossible de mettre à jour le choix ${choiceId} individuellement:`, error.response?.status, error.response?.data);
            // Continue even if individual update fails - we'll try the project PUT
          }
        }
      }
      
      // Save the entire project with product_ref and linked_product in choices
      // Note: The backend endpoint for updating sections individually doesn't exist (404)
      // So we rely on the PUT of the entire project to save the choices
      // However, the backend might not accept product_ref and linked_product in choices via PUT
      // This is a backend limitation - the choices are readOnly according to the model
      
      let response;
      try {
        console.log('Envoi du PUT au backend avec le projet complet...');
        response = await API.put(URLS.PROJECT.details(project.id), payloadToSend);
        
        console.log('Réponse API après sauvegarde:', response.data);
        
        // Check if the backend returned an error or if product_ref or linked_product was saved
        if (response.data) {
          const choiceAfterSave = response.data.steps
            ?.flatMap(step => step.sections || [])
            .flatMap(section => section.choice_items || section.choices || [])
            .find(c => c.id === '297a268b-bad7-4e74-9f33-945e63778ee4');
          
          if (choiceAfterSave) {
            console.log('Choix après sauvegarde:', choiceAfterSave);
            if (choiceAfterSave.product_ref || choiceAfterSave.linked_product) {
              console.log('✅ Produit sauvegardé avec succès:', {
                product_ref: choiceAfterSave.product_ref,
                linked_product: choiceAfterSave.linked_product
              });
            } else {
              console.warn('⚠️ Produit non sauvegardé par le backend');
            }
          }
        }
      } catch (error) {
        console.error('Erreur lors de la sauvegarde:', error);
        console.error('Détails de l\'erreur:', error.response?.data);
        throw error;
      }
      
      // Verify that choices still have product_ref or linked_product after save
      if (response?.data) {
        response.data?.steps?.forEach((step, stepIdx) => {
          step.sections?.forEach((section, sectionIdx) => {
            const choices = section.choice_items || section.choices || [];
            choices.forEach((choice, choiceIdx) => {
              const productId = choice.product_ref || choice.linked_product;
              if (productId) {
                console.log(`✓ Après sauvegarde - Step ${stepIdx}, Section ${sectionIdx}, Choice ${choiceIdx} (${choice.id}): product_ref = ${choice.product_ref}, linked_product = ${choice.linked_product}`);
              } else {
                console.log(`✗ Après sauvegarde - Step ${stepIdx}, Section ${sectionIdx}, Choice ${choiceIdx} (${choice.id}): pas de produit`);
              }
            });
          });
        });
        
        // Update Redux with the response to keep it in sync
        dispatch(setProjectData(response.data));
      }
      
      // Affiche une notification de succès
      toast.success("Projet sauvegardé avec succès !");
      
      // Rediriger vers la page des projets après 1.5 secondes
      setTimeout(() => {
        navigate('/project');
      }, 1500);
      
    } catch (error) {
      // Affiche une notification d'erreur
      toast.error("Erreur lors de la sauvegarde du projet.");
      console.log("erreur :", error);
      console.log("Détails de l'erreur:", error.response?.data);
    } finally {
      setIsSaving(false);
    }
  };

  //const {project_type} = useSelector((state) => state.project);

  // if (error) return <div>Error loading data...</div>;
  // if (!project && isValidating) return <div>Loading...</div>;

  useEffect(() => {

    API.get(URLS.PROJECT.details(projetId)).then((resp) => {
      console.log("Projet chargé depuis l'API:", resp.data);
      
      // Verify that choices have product_ref or linked_product after loading
      resp.data?.steps?.forEach((step, stepIdx) => {
        step.sections?.forEach((section, sectionIdx) => {
          const choices = section.choice_items || section.choices || [];
          choices.forEach((choice, choiceIdx) => {
            const productId = choice.product_ref || choice.linked_product;
            if (productId) {
              console.log(`✓ Après chargement - Step ${stepIdx}, Section ${sectionIdx}, Choice ${choiceIdx} (${choice.id}): product_ref = ${choice.product_ref}, linked_product = ${choice.linked_product}`);
            } else {
              console.log(`✗ Après chargement - Step ${stepIdx}, Section ${sectionIdx}, Choice ${choiceIdx} (${choice.id}): pas de produit`);
            }
          });
        });
      });
      
      dispatch(setProjectData(resp.data));
    });

  }, []);

  useEffect(() => {
    console.log("Ce projet:", project);
  }, [project]);

  return (
    <>
      <div className='container-fluid bg-white overflow-hidden'>
        <div className='bg-colo border border-bottom' style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000, backgroundColor: 'white' }}>
          <div className="d-flex justify-content-between border-btm px-4 shadow" style={{ height: '80px' }}>
            <div>
              <button type="button" className=" mt-4 bg-black-50  border-0 rounded" style={{ height: '40px', width:'40px '}}>
                <Link className="arrow-back-color fw-bold" to="/project">
                  <IoIosArrowBack />
                </Link>
              </button>
            </div>
            <div className="text-center mt-4 pt-2 fw-bold w-50">
              <p className="text-center text">{formatProjectType(project.project_type)} </p>
            </div>
            <div className="">
              <button button type="button p-5" className="p-3 mt-4 bg-black-50 border border-0 rounded three-light" style={{ height: '40px', width:'40px '}}>
                <PiDotsThreeLight />
              </button>
              <button 
                type="button" 
                className="btn button-btn" 
                onClick={handleSave}
                disabled={isSaving}
              >
                {isSaving ? 'Enregistrement...' : 'Save'}
              </button>
            </div>
          </div>
        </div>

        <div className="d-flex" style={{ marginTop: '80px' }}>
          <div className="border-right bg-color shadow" style={{ width: '327px', position: 'fixed', top: '80px', left: 0, height: 'calc(100vh - 80px)', overflowY: 'auto' }}>
            <div className="">
              <div className="mt-5">
                <div>
                  {Array.isArray(steps) && (
                    <div>
                      <ul>
                        {project.steps.map((step, index) => (
                          <li
                            className="mt-1 fw-bold pt-3 text-color"
                            key={step.id}
                            onClick={() => handleStepClick(index)}
                            style={{
                              background: activeStep === index ? '#544A43' : 'transparent',
                              cursor: 'pointer',
                              width: '320px',
                              height: '48px',
                            }}
                          >
                            <span
                              className="p-tag"
                              style={{
                                background: activeStep === index ? '#fff' : 'transparent',
                                width: '4px',
                                height: '48px',
                              }}
                            ></span>
                            <span className="text-uppercase text-center px-4">
                              <Link
                                className={`step-text ${activeStep === index ? 'text-white' : '#544A43'}`}
                                to="#"
                              >
                                {step.name}
                              </Link>
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="p-5 border-black-top" style={{ marginLeft: '327px', width: 'calc(100% - 327px)' }}>
            <div>
              <h3 className="fw-bold text-capitalize">{steps[activeStep]?.name || 'chargement ...'}</h3>
              {/* <p className="p-text">
                Start putting together your course by creating sections, lectures and practice (quizzes, coding exercises and assignments).<br />
                If you're intending to offer your course for free, the total length of video content must be less than 2 hours.
              </p> */}
            </div>
            <div>
              <MainBody  sections={steps[activeStep]?.sections || []} />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default StructureContent;
